<template>
  <div class="modalAutresResultats">
    <div style="border-radius:10px;padding:10px;" class="card">
      <h3>{{ titre }}</h3>
      <hr />
      <div style="margin-top:20px;">
        <div v-if="autres !== null">
          <ul id="listing">
            <li class="autres" v-for="(autre, key) in autres" :key="key">
              {{ autre }}
            </li>
          </ul>
        </div>
        <div v-else>{{ $t("sondage.no-results") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['titre', 'questionId'],
  data () {
    return {
      showAutre: false,
      autres: null
    }
  },
  computed: {
    ...mapGetters(['sondage_autres_resultats', 'type_formulaire'])
  },
  mounted () {
    this.dataAutreOptions()
  },
  methods: {
    dataAutreOptions () {
      switch (this.type_formulaire) {
        case 'simple':
          Object.keys(this.sondage_autres_resultats).forEach((item, key) => {
            if (item === this.questionId) {
              this.autres = Object.values(this.sondage_autres_resultats)[key]
            }
          })
          break
        case 'section':
          Object.keys(this.sondage_autres_resultats).forEach((item, key) => {
            if (item === JSON.stringify(this.questionId)) {
              this.autres = Object.values(this.sondage_autres_resultats)[key]
            }
          })
          break
      }
    }
  }
}
</script>

<style scoped>
.modalAutresResultats {
  font-size:12px;
  -webkit-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 2px 31px 0px rgba(0, 0, 0, 0.75);
  border-radius: 10px;
  margin:50px;
}
#listing {
  overflow: auto !important;
  list-style: inside;
}
.autres {
  text-align: left;
  padding: 5px auto;
  margin: 15px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/resultats/PopupAutresResultats.vue